/**
 * Build the image-search query for an outcome's image picker / prefetch.
 *
 * Generic binary outcome labels — "yes", "no", "true", "false" — search
 * way too broadly on their own (Google's #1 result for "yes" is the band).
 * For those labels we prefix the market title so the search has something
 * concrete to anchor on (e.g. "Will Messi win the Ballon d'Or 2026? - yes").
 *
 * For any other label (proper nouns like "Messi", "Trump", or any custom
 * label the user typed) we use the label verbatim — the user picked it
 * for a reason and it's almost always specific enough.
 */
const GENERIC_BINARY_LABELS: ReadonlySet<string> = new Set(['yes', 'no', 'true', 'false']);

export function buildOutcomeSearchQuery(marketTitle: string, outcomeLabel: string): string {
  const trimmedLabel = outcomeLabel.trim();
  const trimmedTitle = marketTitle.trim();
  if (trimmedLabel.length === 0) {
    return trimmedTitle;
  }
  if (GENERIC_BINARY_LABELS.has(trimmedLabel.toLowerCase())) {
    if (trimmedTitle.length === 0) return trimmedLabel;
    return `${trimmedTitle} - ${trimmedLabel}`;
  }
  return trimmedLabel;
}
